// extracted by mini-css-extract-plugin
module.exports = {"memoryWizard":"styles_memoryWizard__y498f","conversation":"styles_conversation__19Uid","button":"styles_button__HvxuQ","spin":"styles_spin__1s998"};